import { Component, OnInit, Input, OnChanges, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UCInspectionsService } from './uc-inspections.service';
import { InspectionUnsyncedVwMdl, ComponentUnsyncedVwMdl, JobSiteDetailsUnsyncedVwMdl } from '../../entities/inspection/model';
import { AppUris, PageComponent } from '../../entities/app-config/model';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '../../translate';
import { AppService } from '../../app.service';
import { CurrentSelection, SelectionLists, Customer, JobSite, Equipment, UCSystem, AppRoute, ResultMessage } from '../../entities';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { ViewMblFlaggedComponentInfoComponent } from './view-mbl-flagged-component-info/view-mbl-flagged-component-info.component';

@Component({
  selector: 'uc-inspections',
  templateUrl: './uc-inspections.component.html',
  styleUrls: ['./uc-inspections.component.scss']
})
export class UCInspectionsComponent {
    translateSubscription: Subscription;
    userLanguage: string = "english";
    _currentSelection: CurrentSelection = new CurrentSelection();
    _dropDownLists: SelectionLists = new SelectionLists();
    _dropDownListsFiltered: SelectionLists = new SelectionLists();
    _loading: number = 0;

    UCUri: string;
    oldUCUri: string;
    GETUri: string;
    IdentityServerUri: string;
    unSyncedInspectionId: number;
    UriConfig: AppUris = new AppUris();
    inspection: InspectionUnsyncedVwMdl = new InspectionUnsyncedVwMdl();
    leftComponents: ComponentUnsyncedVwMdl[] = [];
    rightComponents: ComponentUnsyncedVwMdl[] = [];
    componentImageSrc: string = "";
    showImagePopUp: boolean = false;
    componentComment: string = "";
    showCommentPopUp: boolean = false;
    routeSubscription: Subscription;
    appUriSubscription: Subscription;
    _showSelectEquipmentModal: boolean = false;
    _submitOperation: ResultMessage = new ResultMessage();
    searchEquipment: any = '';
    constructor(private _inspectionsService: UCInspectionsService,
        private ref: ChangeDetectorRef,
        private _translate: TranslateService,
        private _appService: AppService,
        private _router: Router,
        private _notification: NotificationsService,
      private _route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog  ) {
    }
    ngOnInit() {
        this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
        this.appUriSubscription = this._appService.getAppUris().subscribe(result => setTimeout(() => { this.UriConfig = result; this.ref.detectChanges(); }, 10));
        this.getRouteParam(this._appService.getLastRouteMessage());
        this.routeSubscription = this._appService.getRouteMessage().subscribe(message => setTimeout(() => { this.getRouteParam(message); console.log('timeout getRouteParam'); }, 10));

        this._loading++;
        this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this._dropDownLists.customerList = result; this._dropDownListsFiltered.customerList = result; this.loadEquipment(); }, error => { console.error(error); }, () => { this._loading--; });
        this._loading++;
        this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this._dropDownLists.jobSiteList = result; this.loadEquipment(); }, error => { console.error(error); }, () => { this._loading--; });
        this._loading++;
        this._appService.getEquipmentListForSelection(1, 15000).subscribe(result => { this._dropDownLists.equipmentList = result; this.loadEquipment(); }, error => { console.error(error); }, () => { this._loading--; });
        this._submitOperation.Id = -1;
        this._submitOperation.OperationSucceed = false;
        this._submitOperation.LastMessage = 'This operation cannot be undone! Do you want to continue?';
    }

    ngOnDestroy() {
        this.translateSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
        this.appUriSubscription.unsubscribe();
    }

    getRouteParam(message: AppRoute): void {
        console.log(message);
        if (this._route.snapshot.params.id) {
            this.unSyncedInspectionId = this._route.snapshot.params.id;
            if (this.unSyncedInspectionId != 0) {
                this.loadUnsyncedInspection(this.unSyncedInspectionId);
            }
        }
    }

    loadUnsyncedInspection(unsyncedId: number) {
        this._loading++;
        this._inspectionsService.getUnSyncedInspection(unsyncedId).subscribe(result => {
            if (result.Id == 0)
                return;
            this.inspection = result;
            this.mblInspID = unsyncedId;
            this.leftComponents = result.InspectionDetails.filter(m => m.Side == 1);
            this.rightComponents = result.InspectionDetails.filter(m => m.Side == 2);
            if (this.inspection.MatchedEquipmentId != 0) {
                this.loadEquipment();
            }
        }, error => { console.error(error); }, () => { this._loading--; });

    }
    mblInspID:number;
    updateSMU(event:any){
       this._inspectionsService.UpdateUnsyncedSMU(this.mblInspID,event).subscribe(res=>{
         if(res >0){
            this._notification.success(this.Translate('Operation Succeeded!'), this.Translate('Inspection SMU update successfully!'));
         }
         else{
            this._notification.error(this.Translate('Operation Failed!')); 
         }

         
       });
    }

    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }

    goToSetup() {
        this._router.navigateByUrl('/setup-undercarriage/on-equipment/' + this._currentSelection.equipment.Id);
    }

    goToEquipmentSetup() {
        this._router.navigateByUrl('/setup-equipment?unsyncedid=' + this._appService.simpleNumberEncrypt(this.unSyncedInspectionId));
    }

    customerChanged(event: any): void {
        let customer: Customer = event.value;
        if (!customer) return;
        this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId == customer.Id);
        this._currentSelection.jobSite = new JobSite();
        this._dropDownListsFiltered.equipmentList = [];
        this._currentSelection.equipment = new Equipment();
    }

    jobsiteChanged(event: any): void {
        let jobsite: JobSite = event.value;
        if (!jobsite) return;
        this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId == jobsite.Id);
        this._currentSelection.equipment = new Equipment();
    }

    equipmentChanged(event: any): void {
        let equipment: Equipment = event.option.value;
        if (!equipment) return;
        this._currentSelection.equipment = equipment;
        this._loading++;
        
        this._inspectionsService.GetEquipmentSystems(equipment.Id).subscribe(systems => {
            this._currentSelection.equipment.Systems = [];
            this._currentSelection.equipment.Systems.push(...systems);
        }, error => { console.log(error); }, () => { this._loading--; });
       
    }

    loadEquipment() {
        if (!this.inspection || this.inspection.MatchedEquipmentId == 0) return;
        if (this.inspection.MatchedEquipmentId == this._currentSelection.equipment.Id) return;

        let equipment = this._dropDownLists.equipmentList.find(m => m.Id == this.inspection.MatchedEquipmentId);
        if (!equipment) return;

        let jobsite = this._dropDownLists.jobSiteList.find(m => m.Id == equipment.JobSiteId);
        if (!jobsite) return;

        let customer = this._dropDownLists.customerList.find(m => m.Id == jobsite.CustomerId);
        if (!customer) return;

        this._currentSelection.customer = customer;
        this.customerChanged({ value: customer });

        this._currentSelection.jobSite = jobsite;
        this.jobsiteChanged({ value: jobsite });

        this.equipmentChanged({ value: equipment });
    }

    equipmentSubmitted() {
        if (!this._currentSelection.equipment || this._currentSelection.equipment.Id == 0)
            return;
        this._loading++;
        this._inspectionsService.matchEquipment(this._currentSelection.equipment.Id, this.unSyncedInspectionId, this.inspection.MobileEqId).subscribe(result => {
            console.log(result);
            this.loadUnsyncedInspection(this.unSyncedInspectionId);
            this._showSelectEquipmentModal = false;
        }, error => { console.error(error); }, () => { this._loading--; });
    }

    cancelEquipmentSelection()
    {
        this._showSelectEquipmentModal = false
        this.loadEquipment();
    }

    stepVisibility (step: number): boolean {
        if (this._loading != 0)
            return false;
        switch (step) {
            case 1:
                if (this.inspection.MatchedEquipmentId == 0) return true;
                return false;
            case 2:
                if (this.stepVisibility(1)) return false;
                if (this._currentSelection.equipment.Systems.length != 4)
                    return true;
                return false;
            case 3:
                if (this.stepVisibility(1) || this.stepVisibility(2)) return false;
                if (this.leftComponents.filter(m => m.ComponentId == 0).length > 0) return true;
                if (this.rightComponents.filter(m => m.ComponentId == 0).length > 0) return true;
                return false;
            case 4:
                if (this.stepVisibility(1) || this.stepVisibility(2) || this.stepVisibility(3)) return false;
                return true;
            default:
                return false;
        }
    }

    private checkComponentsForMatching() {

    }

    //showImage(component: ComponentUnsyncedVwMdl) {
    //    this.showImagePopUp = true;
    //    this.componentImageSrc = 'data:image/png;base64,' + component.Image;
    //}
  showImage(image: string) {
    this.showImagePopUp = true;
    this.componentImageSrc = 'data:image/png;base64,' + image;
  }
  showObsImage(image: string) {
    this.showImagePopUp = true;
    this.componentImageSrc = 'data:image/png;base64,' + image;
  }
    showComment(component: ComponentUnsyncedVwMdl) {
        this.showCommentPopUp = true;
        this.componentComment = component.Comments;
    }
  showRecommendations(component: ComponentUnsyncedVwMdl) {
    this.showCommentPopUp = true;
    this.componentComment = component.Recommendations;
  }
    private internalModalClicked: boolean = false;
    modalClicked(divId: number, modalId: number) {
        if (divId == 0) {
            this.internalModalClicked = true;
            return;
        }
        if (this.internalModalClicked) { this.internalModalClicked = false; return; }
        if (modalId == 0) this.showImagePopUp = false;
        else if (modalId == 1) this.showCommentPopUp = false;
    }


    _showSubmitModal: boolean = false;
messageboxcontent:string;
    SubmitMobileInspection() {
        this._loading++;
        this._inspectionsService.submitUnsynced(this._currentSelection.equipment.Id, this.unSyncedInspectionId, this.inspection.MobileEqId).subscribe(result => {
            this._submitOperation = result;
            if (result.OperationSucceed) {
                this._notification.success(this.Translate('Operation Succeeded!'), this.Translate('Inspection saved successfully!'));
                this._showSubmitModal = false;
                setTimeout(() => { this._router.navigateByUrl('/');}, 2000);
            } else {
              this._showSubmitModal = true;
              this.messageboxcontent = result.LastMessage;
                //this._notification.error(this.Translate('Operation Failed!'), this.Translate(result.LastMessage));
            }
        }, error => { console.error(error); }, () => { this._loading--; });
    }
    showAppUris() {
        console.log(this.UriConfig);
    }
  OpenMblFlaggedComponent(MblInspectionDetailId: number, componentTypeId: number, componentId: number) {
    const editSeralNumber = this._dialog.open(ViewMblFlaggedComponentInfoComponent, {
      data: {
        unSyncedInspectionId: this.unSyncedInspectionId,
        componentTypeId: componentTypeId,
        ComponentId: componentId,
        MblInspectionDetailId: MblInspectionDetailId,
      }
    });
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }


  filterEquipment(): void {

  const value = typeof this.searchEquipment === 'string'
    ? this.searchEquipment.toLowerCase()
    : this.searchEquipment?.Serial?.toLowerCase() || '';

  this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(x =>
      x.Serial.toLowerCase().includes(value) ||
      x.Unit.toLowerCase().includes(value)
  );
  this._currentSelection.equipment = new Equipment();
  

}
displayEquipment(equipment: any): string {

  return equipment
    ? `${equipment.Serial} | ${equipment.Unit}`
    : '';

}
}
